import { render, staticRenderFns } from "./ranking-chart.vue?vue&type=template&id=ffa9b280&"
import script from "./ranking-chart.vue?vue&type=script&lang=js&"
export * from "./ranking-chart.vue?vue&type=script&lang=js&"
import style0 from "./ranking-chart.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports